"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZES_INT = exports.SIZES = exports.ICON_SIZE = exports.CARRIER_TYPES = exports.CARRIER_ICONS = exports.BORDER_RADIUS = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _SIZES_INT;

var SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
exports.SIZES = SIZES;
var SIZES_INT = (_SIZES_INT = {}, (0, _defineProperty2.default)(_SIZES_INT, SIZES.SMALL, 20), (0, _defineProperty2.default)(_SIZES_INT, SIZES.MEDIUM, 32), (0, _defineProperty2.default)(_SIZES_INT, SIZES.LARGE, 40), _SIZES_INT);
exports.SIZES_INT = SIZES_INT;
var CARRIER_TYPES = {
  airline: 'airline',
  bus: 'bus',
  train: 'train',
  private_transfer: 'private_transfer',
  ferry: 'ferry'
};
exports.CARRIER_TYPES = CARRIER_TYPES;
var CARRIER_ICONS = {
  airline: 'FlightIcon',
  bus: 'DirectionsBus',
  train: 'Train',
  private_transfer: 'DriveEta',
  ferry: 'DirectionsBoat'
};
exports.CARRIER_ICONS = CARRIER_ICONS;
var ICON_SIZE = {
  small: 'normal',
  medium: 'titleMedium',
  large: 'titleExtraLarge'
};
exports.ICON_SIZE = ICON_SIZE;
var BORDER_RADIUS = '3px';
exports.BORDER_RADIUS = BORDER_RADIUS;